import {useRouteError} from 'react-router'
import {Trans, useTranslation} from 'react-i18next'
import {Button} from '@translated/babele-react'
import {TWebsiteLink} from './TLink/TWebsiteLink'

export function ErrorBoundary() {
  const error = useRouteError()
  const {t} = useTranslation('common')

  if (error instanceof Error) console.error('Error stack trace is', error.stack)

  return (
    <main className="h-screen p-2">
      <div className="flex h-full items-center justify-center rounded-lg bg-neutral-25 py-4">
        <div className="flex max-w-[30rem] flex-col items-center gap-4 text-center">
          <div className="flex flex-col gap-2">
            <h1 className="text-display-md">
              <Trans
                t={t}
                i18nKey="generic_errors.not_found.title"
                components={{span: <span className="text-critical-1000" />}}
              />
            </h1>
            <p className="mx-auto max-w-[25rem] pb-8 text-neutral-800">
              {t('generic_errors.not_found.description')}
            </p>
          </div>
          <div className="flex justify-center">
            <Button variant={{tone: 'accent', size: 'lg'}}>
              <TWebsiteLink to="/translate">{t('generic_errors.not_found.cta')}</TWebsiteLink>
            </Button>
          </div>
        </div>
      </div>
    </main>
  )
}
